import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { User, LoginCredentials } from '../types'
import authApi from '../services/authApi'
import { queryClient } from '../queryClient'

interface AuthState {
  token: string | null
  user: User | null
  isAuthenticated: boolean
  
  // Actions
  login: (credentials: LoginCredentials) => Promise<void>
  register: (payload: {
    phone: string
    password: string
    sms_code: string
    nickname?: string
    invite_code?: string
  }) => Promise<void>
  setSession: (token: string, user: User) => void
  logout: () => void
  setUser: (user: User) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isAuthenticated: false,

      login: async (credentials) => {
        queryClient.clear()
        const response = credentials.loginType === 'code'
          ? await authApi.loginWithCode({
              phone: credentials.phone,
              sms_code: credentials.code || '',
            })
          : await authApi.loginWithPassword({
              phone: credentials.phone,
              password: credentials.password || '',
            })
        const { access_token, user } = response
        
        // 存储token到localStorage
        localStorage.setItem('access_token', access_token)
        
        set({
          token: access_token,
          user,
          isAuthenticated: true,
        })
      },

      register: async (payload) => {
        queryClient.clear()
        const response = await authApi.register(payload)
        const { access_token, user } = response
        localStorage.setItem('access_token', access_token)
        set({
          token: access_token,
          user,
          isAuthenticated: true,
        })
      },

      setSession: (token, user) => {
        queryClient.clear()
        localStorage.setItem('access_token', token)
        set({ token, user, isAuthenticated: true })
      },

      logout: () => {
        queryClient.clear()
        localStorage.removeItem('access_token')
        set({
          token: null,
          user: null,
          isAuthenticated: false,
        })
      },

      setUser: (user) => {
        set({ user })
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ token: state.token, user: state.user, isAuthenticated: state.isAuthenticated }),
    }
  )
)
